import React, { useEffect, useState } from "react";
import { EntityLink } from "@/components/EntityLink";
import { api } from "@/lib/api";
import { PhoneDisplay } from "@/components/PhoneDisplay";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Sims() {
  const [sims, setSims] = useState([]);
  useEffect(() => { api.get("/sims").then((r) => setSims(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="sims-page">
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Servizi</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1">SIM attive</h1>
      </div>
      <Card className="glow-border">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Numero</TableHead><TableHead>Cliente</TableHead><TableHead>Operatore</TableHead>
            <TableHead>ICCID</TableHead><TableHead>Piano</TableHead><TableHead>Tipo</TableHead><TableHead>Stato</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {sims.map((s) => (
              <TableRow key={s.id} data-testid={`sim-row-${s.id}`}>
                <TableCell className="font-medium"><EntityLink kind="sim" id={s.id} data-testid={`sim-detail-link-${s.id}`}><PhoneDisplay value={s.phone_number} data-testid={`sim-phone-display-${s.id}`} /></EntityLink></TableCell>
                <TableCell><EntityLink kind="customer" id={s.customer_id} data-testid={`sim-customer-link-${s.id}`}>{s.customer_name}</EntityLink></TableCell>
                <TableCell><Badge variant="outline">{s.operator}</Badge></TableCell>
                <TableCell className="font-mono text-xs">{s.iccid}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{s.plan_name || "—"}</TableCell>
                <TableCell className="text-sm">{s.activation_type === "portability" ? "Portabilità" : "Nuovo"}</TableCell>
                <TableCell><Badge className="bg-teal-600 hover:bg-teal-600">Attiva</Badge></TableCell>
              </TableRow>
            ))}
            {sims.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-8">Nessuna SIM attivata.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
